function ChildrenService(BBModel) {
    'ngInject';

    return {
        promise: true,
        unwrap(resource) {
            return resource
                .$get('companies')
                .then(items => items.map(i => new BBModel.Company(i)))
                .catch(console.error);
        }
    };
}

angular
    .module('BB')
    .service('BB.Service.children', ChildrenService);



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_services/bb_service_children.service.js